import React from 'react';
import SvgIcon from './SvgIcon';

const Android = props => {
    return (
        <SvgIcon viewBox="0 0 24 26" fill="none" {...props}>
            <rect x={1.5} y={9.891} width={2} height={8} rx={1} stroke="currentColor" />
            <rect x={20.5} y={9.891} width={2} height={8} rx={1} stroke="currentColor" />
            <path
                d="M5 9.39v-.5h-.5v.5H5zm14 0h.5v-.5H19v.5zm-11 11h.5v-.5H8v.5zm3 0v-.5h-.5v.5h.5zm2 0h.5v-.5H13v.5zm3 0v-.5h-.5v.5h.5zM5 9.89h14v-1H5v1zm.5 8.5v-9h-1v9h1zm1.5 1.5a1.5 1.5 0 01-1.5-1.5h-1a2.5 2.5 0 002.5 2.5v-1zm1 0H7v1h1v-1zm-.5.5v3.5h1v-3.5h-1zm0 3.5a2 2 0 002 2v-1a1 1 0 01-1-1h-1zm2 2a2 2 0 002-2h-1a1 1 0 01-1 1v1zm2-2v-3.5h-1v3.5h1zm1.5-4h-2v1h2v-1zm-.5.5v3.5h1v-3.5h-1zm0 3.5a2 2 0 002 2v-1a1 1 0 01-1-1h-1zm2 2a2 2 0 002-2h-1a1 1 0 01-1 1v1zm2-2v-3.5h-1v3.5h1zm.5-4h-1v1h1v-1zm1.5-1.5a1.5 1.5 0 01-1.5 1.5v1a2.5 2.5 0 002.5-2.5h-1zm0-9v9h1v-9h-1z"
                fill="currentColor"
            />
            <path d="M19 8.02H5c0-3.314 3.134-6 7-6s7 2.686 7 6z" stroke="currentColor" />
            <path
                d="M7.467.375a.25.25 0 00-.434.25l.434-.25zm1.25 2.165L7.467.375l-.434.25 1.25 2.165.434-.25zM16.716.625a.25.25 0 00-.433-.25l.433.25zm-.433-.25l-1.25 2.165.434.25 1.25-2.165-.433-.25z"
                fill="currentColor"
            />
            <circle cx={15.25} cy={5.141} r={0.75} fill="currentColor" />
            <circle cx={8.75} cy={5.141} r={0.75} fill="currentColor" />
        </SvgIcon>
    );
};

Android.displayName = 'AndroidIcon';

export default Android;
